import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import { SimilarMovie } from '../../interfaces/similar-movie-response';
import { Router } from '@angular/router';
import { Movie } from 'src/app/interfaces/cartelera-response';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

@Component({
  selector: 'app-similars-slideshow',
  templateUrl: './similars-slideshow.component.html',
  styleUrls: ['./similars-slideshow.component.css']
})
export class SimilarsSlideshowComponent implements OnInit, AfterViewInit {

  @Input() similars: SimilarMovie[] = [];

  constructor( private router: Router) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    const swiper = new Swiper('.swiper-container-similars', {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

  }

  onMovieClick( id: number ): void{
    console.log(id);
    this.router.navigate(['/pelicula', id]);
  }

}
